import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 20px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: var(--glass-border);
  }
`;

const Item = styled.div`
  position: relative;
  padding-left: 50px;
  margin-bottom: 30px;

  &::before {
    content: '';
    position: absolute;
    left: 11px;
    top: 5px;
    width: 20px;
    height: 20px;
    background: var(--accent);
    border: 4px solid var(--bg-base);
    border-radius: 50%;
    box-shadow: 0 0 10px var(--accent-glow);
  }
`;

const DateText = styled.div`
  font-size: 12px;
  color: var(--accent);
  font-weight: bold;
  margin-bottom: 5px;
`;

const Title = styled.h4`
  margin: 0 0 8px 0;
  color: var(--text-primary);
  font-size: 18px;
`;

const Text = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
`;

const VerticalTimelineWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Item>
        <DateText>Schritt 1</DateText>
        <Title>Anfrage & Beratung</Title>
        <Text>Kostenlose Analyse deines aktuellen Vertrags und individuelle Angebotserstellung.</Text>
      </Item>
      <Item>
        <DateText>Schritt 2</DateText>
        <Title>Abschluss & Bonitätsprüfung</Title>
        <Text>Digitaler Vertragsabschluss und automatische Bonitätsprüfung in Echtzeit.</Text>
      </Item>
      <Item>
        <DateText>Schritt 3</DateText>
        <Title>Versand & Aktivierung</Title>
        <Text>Express-Versand der Hardware und SIM-Karte. SIM direkt per App aktivierbar.</Text>
      </Item>
    </Wrapper>
  );
};

registry.register('vertical_timeline', {
  label: 'Timeline',
  icon: '⏳',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: VerticalTimelineWidget,
  inspectorControls: [
    { tab: 'style', groups: [{ title: 'Container', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Max. Breite', type:'text'}] }] }
  ]
});
